//moved from main.ts to avoid circular dependency with app.module.ts
export function getBaseUrl() {
  return document.getElementsByTagName('base')[0].href;
}

/**
 * Gets the expected issuer for the oauth2/oidc tokens.  If this
 * is not set correctly, you will see an error in the browser console
 * "invalid issuer in discovery document" and authentication will not work.
 *
 * This is the url of the identity provider.
 */
export function getOauthOidcIssuer() {
    //Currently, the issuer is the same web application as NeDss,
    //so this is based on getBaseUrl(). In the future, the issuer might
    //come from a separate web application, in which case the issuer would need to be
    //specified differently.
    let issuerUrl = getBaseUrl();

    //For some reason, if the application is deployed to the root directory, issuer must
    //end with a slash, but if the application is deployed to a subdirectory, the issuer
    //must *not* end with a slash. This is based on experimentation, not documentation, so
    //not sure precisely why that happens.
    //At any rate, we compensate here so that discovery document validation doesn't fail.
    //   | protocol || domain|| port|| subdir  |
    if (/^https?:\/\/[\w\d\.]+(:\d+)?\/[\w\d\.]+/.test(issuerUrl)) {
        //we're deployed to a subdirectory
        if (issuerUrl.endsWith('/')) {
            issuerUrl = issuerUrl.slice(0, -1);
        }
    }
    else if (!issuerUrl.endsWith('/')) {
        //we're deployed to the root
        issuerUrl = issuerUrl + '/';
    }

    return issuerUrl;
}

/**
 * This function returns true if we should allow sending the bearer token
 * to the url, and false if we should not.  Bearer tokens directly allow
 * access to the application, so we only want them sent to our api endpoints.
 * @param url - The url to test
 */
export function shouldSendBearerToken(url: string): boolean {
    //Somewhere by the time the url reaches us, it seems to have been put into all lower case.
    //Since we won't have endpoints that differ only by case, we ignore case when checking the url.
    //Since I haven't found that behavior documented, we explicitly put both into lower case.

    //only send bearer tokens to our api endpoints.
    let allowedUrl = getBaseUrl().toLowerCase() + 'api/';
    let urlLower = url.toLowerCase();

    return urlLower.startsWith(allowedUrl);
}
